// src/pages/LikedPosts.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase-config';
import { collection, query, where, getDocs } from 'firebase/firestore';
import NewsCard from '../components/newsCard';
import './PageStyles.css';

const LikedPosts = () => {
  const { currentUser } = useAuth();
  const [likedNews, setLikedNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLikedPosts = async () => {
      if (!currentUser) return;
      setLoading(true);
      try {
        // Query userNews where the 'likedBy' array contains the current user's ID
        const q = query(collection(db, 'userNews'), where('likedBy', 'array-contains', currentUser.uid));
        const querySnapshot = await getDocs(q);
        const newsList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setLikedNews(newsList);
      } catch (error) {
        console.error("Error fetching liked posts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLikedPosts();
  }, [currentUser]);

  return (
    <div className="page-container">
      <h1>Liked Posts</h1>
      {loading ? (
        <p>Loading liked posts...</p>
      ) : likedNews.length > 0 ? (
        <div className="news-grid">
          {likedNews.map(item => <NewsCard key={item.id} newsItem={item} />)}
        </div>
      ) : (
        <p>You haven't liked any posts yet.</p>
      )}
    </div>
  );
};

export default LikedPosts;